"use client";

import React from "react";

import { _buildTooltip } from "./common";
import { ITooltipProps } from "./Tooltip";

export interface IDismissableTooltipProps
  extends Omit<ITooltipProps, "isOpen"> {
  onDismiss?: (e?: React.MouseEvent) => void;
}

export const DismissableTooltip = (
  dismissableTooltipProps: IDismissableTooltipProps
) => _buildTooltip(dismissableTooltipProps, true);
